import { render, staticRenderFns } from "./ComponentBase.vue?vue&type=template&id=0f18e39c&scoped=true&"
import script from "./ComponentBase.vue?vue&type=script&lang=js&"
export * from "./ComponentBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f18e39c",
  null
  
)

export default component.exports